import { render, staticRenderFns } from "./TermsSignature.vue?vue&type=template&id=13862230&scoped=true"
import script from "./TermsSignature.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsSignature.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TermsSignature.vue?vue&type=style&index=0&id=13862230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13862230",
  null
  
)

export default component.exports